import { render, staticRenderFns } from "./InstituteEdit.vue?vue&type=template&id=7e1cb6e5&"
import script from "./InstituteEdit.vue?vue&type=script&lang=js&"
export * from "./InstituteEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports